import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';
import { Text } from '../../UI/Text';

export const DefaultSummaryContainer = styled.div`
    width: 100%;

    display: flex;
    justify-content: center;
    flex-direction: column;
    position: relative;
    padding: 30px;
`;

export const WorkoutSummaryContainer = styled.div`
    width: 100%;
    // margin-top: -60px;
    padding: 0 30px;
    overflow-y: auto;

    ${media.desktop`
        padding: 0 30px;
    `};

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const ScrollWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
`;

export const QrCodeDescription = styled.div`
    margin-left: 16px;
`;

export const QRSubtitle = styled(Text)`
    @media (max-width: 1200px) {
        display: none;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Components/LeaderboardSummary/style.js